export default "__VITE_ASSET__e7339859__"